/**
 * @hidden
 */
var BaseEvent = /** @class */ (function () {
    /**
     * @hidden
     */
    function BaseEvent(target) {
        this.target = target;
    }
    return BaseEvent;
}());
export { BaseEvent };
//# sourceMappingURL=base-event.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-charts/dist/es/events/base-event.js
// module id = 88
// module chunks = 29